import { TFunction } from 'i18next';
import { SelectWithSearchDataArrayInterface } from '@components/core/select-with-categories/select-with-categories.interface';
import { ControlsAutomationColor, StudyAutomationColor } from 'types/graphql-global-types';

export const STUDY_AUTOMATION_COLOR_COLUMN_TYPES: SelectWithSearchDataArrayInterface[] = [
    { id: StudyAutomationColor.NONE, text: 'Select a Value', item: '', active: true },
    { id: StudyAutomationColor.RED_ONLY, text: 'Red Only', item: StudyAutomationColor.RED_ONLY, active: true },
    { id: StudyAutomationColor.RED_AMBER, text: 'Red & Amber', item: StudyAutomationColor.RED_AMBER, active: true },
    { id: StudyAutomationColor.RED_PURPLE, text: 'Red & Purple', item: StudyAutomationColor.RED_PURPLE, active: true },
    {
        id: StudyAutomationColor.RED_AMBER_PURPLE,
        text: 'Red, Amber & Purple',
        item: StudyAutomationColor.RED_AMBER_PURPLE,
        active: true,
    },
];

export const CONTROLS_AUTOMATION_COLOR_COLUMN_TYPES = (t: TFunction): SelectWithSearchDataArrayInterface[] => {
    return [
        { id: ControlsAutomationColor.NONE, text: 'Select a Value', item: '', active: true },
        {
            id: ControlsAutomationColor.UPPER_RED,
            text: t('UPPER_RED'),
            item: ControlsAutomationColor.UPPER_RED,
            active: true,
        },
        {
            id: ControlsAutomationColor.LOWER_RED,
            text: t('LOWER_RED'),
            item: ControlsAutomationColor.LOWER_RED,
            active: true,
        },
        {
            id: ControlsAutomationColor.UPPER_RED_LOWER_RED,
            text: t('UPPER_RED_LOWER_RED'),
            item: ControlsAutomationColor.UPPER_RED_LOWER_RED,
            active: true,
        },
        {
            id: ControlsAutomationColor.UPPER_AMBER_UPPER_RED,
            text: t('UPPER_AMBER_UPPER_RED'),
            item: ControlsAutomationColor.UPPER_AMBER_UPPER_RED,
            active: true,
        },
        {
            id: ControlsAutomationColor.LOWER_AMBER_LOWER_RED,
            text: t('LOWER_AMBER_LOWER_RED'),
            item: ControlsAutomationColor.LOWER_AMBER_LOWER_RED,
            active: true,
        },
        {
            id: ControlsAutomationColor.UPPER_RED_UPPER_AMBER_LOWER_RED,
            text: t('UPPER_RED_UPPER_AMBER_LOWER_RED'),
            item: ControlsAutomationColor.UPPER_RED_UPPER_AMBER_LOWER_RED,
            active: true,
        },
        {
            id: ControlsAutomationColor.UPPER_RED_LOWER_AMBER_LOWER_RED,
            text: t('UPPER_RED_LOWER_AMBER_LOWER_RED'),
            item: ControlsAutomationColor.UPPER_RED_LOWER_AMBER_LOWER_RED,
            active: true,
        },
        {
            id: ControlsAutomationColor.UPPER_RED_UPPER_AMBER_LOWER_AMBER_LOWER_RED,
            text: t('UPPER_RED_UPPER_AMBER_LOWER_AMBER_LOWER_RED'),
            item: ControlsAutomationColor.UPPER_RED_UPPER_AMBER_LOWER_AMBER_LOWER_RED,
            active: true,
        },
    ];
};
